"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var date_fns_1 = require("date-fns");
var React = __importStar(require("react"));
var react_datepicker_1 = __importDefault(require("react-datepicker"));
var informationModal_1 = __importDefault(require("./informationModal"));
exports.default = (function (props) {
    var modalHeader = props.modalHeader, modalText = props.modalText, oosButtonText = props.oosButtonText;
    var _a = __read(React.useState(null), 2), firstName = _a[0], setFirstName = _a[1];
    var _b = __read(React.useState(null), 2), lastName = _b[0], setLastName = _b[1];
    var _c = __read(React.useState(null), 2), email = _c[0], setEmailAddress = _c[1];
    var _d = __read(React.useState(null), 2), dueDate = _d[0], setDueDate = _d[1];
    var _e = __read(React.useState(''), 2), gender = _e[0], setGender = _e[1];
    var _f = __read(React.useState(false), 2), disabledButton = _f[0], setDisabled = _f[1];
    var _g = __read(React.useState('pointer'), 2), cursorStyle = _g[0], setCursorStyle = _g[1];
    var _h = __read(React.useState(false), 2), isModalOpen = _h[0], setIsModalOpen = _h[1];
    var _j = __read(React.useState(oosButtonText), 2), buttonText = _j[0], setButtonText = _j[1];
    var privacyPolicyNotice = (React.createElement("div", { className: 'text-gray font-italic' },
        "**By signing up, you agree to our Privacy Policy and Terms of Use. For all the giveaway rules,",
        React.createElement("a", { href: '/pages/freediaperterms', className: 'padding-left-1' }, "click here"),
        "."));
    var handleSubmit = function (e) {
        e.preventDefault();
        // add the submission to klaviyo
        var _learnq = window._learnq;
        if (_learnq) {
            _learnq.push([
                'identify',
                {
                    $email: email,
                    $first_name: firstName,
                    $last_name: lastName,
                },
            ]);
            _learnq.push([
                'track',
                'Out-of-stock New Mom Diaper Giveaway Submission',
                {
                    campaign: 'New Mom Diaper Giveaway',
                    dueDate: (0, date_fns_1.format)(dueDate, 'yyyy-MM-dd'),
                    gender: gender,
                },
            ]);
            setDisabled(true);
            setCursorStyle('not-allowed');
            setButtonText('Thank you!');
        }
    };
    return (React.createElement("div", { className: 'padding-vertical-5' },
        React.createElement("form", { onSubmit: handleSubmit },
            React.createElement("div", { className: 'grid-x' },
                React.createElement("div", { className: 'small-12 medium-6 text-gray text-left', style: { fontSize: '10px' } },
                    "FIRST NAME",
                    React.createElement("div", { className: 'padding-right-4' },
                        React.createElement("input", { type: 'text', onChange: function (e) { return setFirstName(e.target.value); }, placeholder: 'First Name', required: true }))),
                React.createElement("div", { className: 'small-12 medium-6 text-gray text-left', style: { fontSize: '10px' } },
                    "LAST NAME",
                    React.createElement("div", { className: 'padding-right-4' },
                        React.createElement("input", { type: 'text', onChange: function (e) { return setLastName(e.target.value); }, placeholder: 'Last Name', required: true })))),
            React.createElement("div", { className: 'text-gray text-left', style: { fontSize: '10px' } }, "EMAIL"),
            React.createElement("div", { className: 'padding-right-4' },
                React.createElement("input", { type: 'email', onChange: function (e) { return setEmailAddress(e.target.value); }, placeholder: 'Email Address', required: true })),
            React.createElement("div", { className: 'grid-x' },
                React.createElement("div", { className: 'small-6 medium-3 text-gray text-left padding-right-4', style: { fontSize: '10px' } },
                    "DUE DATE/BABY BIRTHDAY",
                    React.createElement("div", { className: '' },
                        React.createElement(react_datepicker_1.default, { maxDate: (0, date_fns_1.addYears)(new Date(), 1), onChange: function (deliveryDate) { return setDueDate(deliveryDate); }, placeholderText: 'Due Date', selected: dueDate, required: true }))),
                React.createElement("div", { className: 'small-6 medium-9 text-gray text-left', style: { fontSize: '10px' } },
                    "BABY'S GENDER",
                    React.createElement("div", { className: 'padding-right-5' },
                        React.createElement("select", { required: true, name: 'Gender', value: gender, onChange: function (e) {
                                setGender(e.target.value);
                            }, style: { display: 'block' } },
                            React.createElement("option", { value: '' }, "Gender"),
                            React.createElement("option", { value: 'male' }, "Male"),
                            React.createElement("option", { value: 'female' }, "Female"),
                            React.createElement("option", { value: 'prefer_not_say' }, "Prefer not to say"))))),
            React.createElement("div", null, privacyPolicyNotice),
            React.createElement("div", { className: 'padding-top-10' },
                React.createElement("button", { className: (0, classnames_1.default)("bg-".concat(disabledButton ? 'gray' : 'light-wisteria', " cursor-disabled text-white text-center width-50 padding-vertical-4")), disabled: disabledButton, type: 'submit', style: { cursor: cursorStyle } }, buttonText))),
        React.createElement("div", { className: 'padding-top-3' },
            React.createElement("button", { className: 'text-gray text-underline', style: { background: 'none', border: 'none' }, onClick: function () {
                    setIsModalOpen(true);
                } }, "WHY DO YOU NEED MY INFORMATION?")),
        React.createElement(informationModal_1.default, { isOpen: isModalOpen, handleClose: function () { return setIsModalOpen(false); }, modalHeader: modalHeader, modalText: modalText })));
});
